<template>
    <div v-if="getLatestPointInfo">
        <make-point-header></make-point-header>
        <make-point-info></make-point-info>
        <make-point-btn></make-point-btn>
    </div>
</template>

<script>
    import MakePointHeader from 'pages/commons/header/Header'
    import MakePointInfo from './components/Info'
    import MakePointBtn from './components/Btn'
    
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                status: 0
            }
        },
        components: {
            MakePointHeader,
            MakePointInfo,
            MakePointBtn
        },
        created () {
            this.loadLatestPointInfo()
        },
        watch: {
            getLatestPointInfoLoadStatus (status) {
                this.status = status
            },
            getMakePointStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            status (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            ...mapGetters(['getLatestPointInfo'
                          ,'getLatestPointInfoLoadStatus'
                          ,'getMakePointStatus'
                ])
        },
        methods: {
            loadLatestPointInfo () {
                this.$store.dispatch('loadLatestPointInfo')
            }
        }
    }
</script>

<style>

</style>
